import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        mainContainer: {
            marginBottom: 2,
            padding: 1,
            color: colors.color9,
            display: 'flex',
            gap: 2,
            bgcolor: 'white'
        },
        superior: {
            width: '100%'
        },
        iconSetting: {
            '& .MuiSvgIcon-root': {
                fontSize: '2rem'
            },
            paddingTop: '4px'
        },
        dropList: {
            display: 'flex',
            '& .MuiTypography-root': {
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
            },
        },
        titleAndIcon: {
            display: 'flex',
            alignItems: 'center'
        },
        title: {
            flex: 1
        }
    }
}